/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Confirm_LocaleInputs */

const cs_property_ai_confirm_locale = /** @type {(inputs: Property_Ai_Confirm_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdit jazyk`)
};

const en_property_ai_confirm_locale = /** @type {(inputs: Property_Ai_Confirm_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm language`)
};

/**
* | output |
* | --- |
* | "Confirm language" |
*
* @param {Property_Ai_Confirm_LocaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_confirm_locale = /** @type {((inputs?: Property_Ai_Confirm_LocaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Confirm_LocaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_confirm_locale(inputs)
	return cs_property_ai_confirm_locale(inputs)
});